export default {"src":"/_next/static/media/USD.f915adfd.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};